import React from 'react';
import { Modal } from 'components/organisms/Modal';
import { useWindowSize } from 'hooks';
import { AuthRole } from 'common/enums/hooks/auth-role.enum';
import { useNavigate } from 'react-router-dom';
import { Button } from 'legacy-components/componets';
import { AppRoute } from 'common/enums/enums';

interface RoleSwitchModalProps {
  isOpen: boolean;
  onClose: () => void;
  targetRole?: AuthRole;
}

export const RoleSwitchModal: React.FC<RoleSwitchModalProps> = ({
  isOpen,
  onClose,
  targetRole,
}) => {
  const { isMobile } = useWindowSize();
  const navigate = useNavigate();

  if (!targetRole) {
    return null;
  }

  const getRoleDisplayName = (role: AuthRole): string => {
    switch (role) {
      case AuthRole.Landlord:
        return 'Landlord';
      case AuthRole.Renter:
        return 'Renter';
      default:
        return role;
    }
  };

  const handleConfirm = () => {
    const profilePath = targetRole === AuthRole.Landlord 
      ? AppRoute.LANDLORD_PROFILE_INFO
      : AppRoute.PROFILE_INFO;

    navigate(profilePath);
    onClose();
  };

  const getModalContent = () => {
    const roleDisplayName = getRoleDisplayName(targetRole);
    
    return {
      title: `Switch to ${roleDisplayName}`,
      description: `You're switching to ${roleDisplayName} role. You may need to provide additional information to complete your profile for this role.`,
      buttonText: 'Go to profile',
    };
  };

  const { title, description, buttonText } = getModalContent();

  return (
    <Modal
      titleClassName="text-[22px]"
      isFullScreen={isMobile}
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      contentClassName={'w-[700px]'}
    >
      <div className="space-y-6">
        <p className="text-gray-600">
          {description}
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-end">
          <Button label={'Cancel'} theme={'secondary'} onClick={onClose} className={'w-full col-span-3'} />
          <Button label={buttonText} theme={'primary'} onClick={handleConfirm} className={'w-full col-span-3'} />
        </div>
      </div>
    </Modal>
  );
};
